<template>
    <div class="ticker__wrapper">
        <div v-if="!editMode" class="display__container">
             <div class="display__CTA__wrapper">
                <button class="drag-handle" draggable="true"  @mousedown="startDrag">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.30952 4.50435C6.03273 4.50435 6.61905 3.94373 6.61905 3.25217C6.61905 2.56062 6.03273 2 5.30952 2C4.58629 2 4 2.56062 4 3.25217C4 3.94373 4.58629 4.50435 5.30952 4.50435ZM5.30952 9.51304C6.03273 9.51304 6.61905 8.9524 6.61905 8.26087C6.61905 7.56934 6.03273 7.0087 5.30952 7.0087C4.58629 7.0087 4 7.56934 4 8.26087C4 8.9524 4.58629 9.51304 5.30952 9.51304ZM6.61905 13.2696C6.61905 13.9611 6.03273 14.5217 5.30952 14.5217C4.58629 14.5217 4 13.9611 4 13.2696C4 12.578 4.58629 12.0174 5.30952 12.0174C6.03273 12.0174 6.61905 12.578 6.61905 13.2696ZM10.5476 4.50435C11.2708 4.50435 11.8571 3.94373 11.8571 3.25217C11.8571 2.56062 11.2708 2 10.5476 2C9.82441 2 9.2381 2.56062 9.2381 3.25217C9.2381 3.94373 9.82441 4.50435 10.5476 4.50435ZM11.8571 8.26087C11.8571 8.9524 11.2708 9.51304 10.5476 9.51304C9.82441 9.51304 9.2381 8.9524 9.2381 8.26087C9.2381 7.56934 9.82441 7.0087 10.5476 7.0087C11.2708 7.0087 11.8571 7.56934 11.8571 8.26087ZM10.5476 14.5217C11.2708 14.5217 11.8571 13.9611 11.8571 13.2696C11.8571 12.578 11.2708 12.0174 10.5476 12.0174C9.82441 12.0174 9.2381 12.578 9.2381 13.2696C9.2381 13.9611 9.82441 14.5217 10.5476 14.5217Z" fill="#9D9FA3"/>
                    </svg>
                </button>
                <button class="edit__button" @click="handleEdit">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.70711 13.5001L13.7071 5.50008L10.5 2.29297L2.5 10.293V13.5001H5.70711ZM10.5 3.70718L12.2929 5.50008L11 6.793L9.20712 5.00009L10.5 3.70718ZM8.49999 5.7072L10.2929 7.50007L5.29289 12.5001H3.5V10.7072L8.49999 5.7072Z" fill="#9D9FA3"/>
                    </svg>
                </button>
                <button class="modal__button" @click="handleModalDelete">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_12_285)">
                        <path d="M7 6H6V12H7V6Z" fill="#9D9FA3"/>
                        <path d="M10 6H9V12H10V6Z" fill="#9D9FA3"/>
                        <path d="M2 3V4H3V14C3 14.2652 3.10536 14.5196 3.29289 14.7071C3.48043 14.8946 3.73478 15 4 15H12C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14V4H14V3H2ZM4 14V4H12V14H4Z" fill="#9D9FA3"/>
                        <path d="M10 1H6V2H10V1Z" fill="#9D9FA3"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_12_285">
                        <rect width="16" height="16" fill="white"/>
                        </clipPath>
                    </defs>
                    </svg>
            </button>
            </div>
             <div class="display__group">
                <div class="MessageBlock">
                <h3 class="display__title">Ticker #{{ index + 1 }}</h3>
                <div class="text__group">
                    <h4 class="display__text">Message</h4>
                    <p class="display_value">{{text}}</p>
                </div>
                <div class="text__group" style="margin-top: 0;">
                    <p v-show="lineBreak" class="display_value display__checkbox">
                        <svg width="15" height="13" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.29541 4.06252L0.943138 3.39775L3.19314 5.61366L7.84655 0.977295L8.51132 1.64207L3.19314 6.9432L0.29541 4.06252Z" fill="#2B2B2B"/>
</svg>
                        With Break (Only applicable to CTA)
                    </p>
                </div>
                </div>
                <div class="CTABlock" v-for="(CTABlock, ctaIndex) in cta" :key="CTABlock.id" >
                        <CTABlocks :CTABlock="CTABlock" :editMode="editMode" :tickerIndex="index" :ctaIndex="ctaIndex" />
                </div>
            </div>
        </div>
        <div v-else class="input__container">
            <div class="input__CTA__wrapper">
                <!-- <button class="drag-handle" @mousedown="startDrag">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.30952 4.50435C6.03273 4.50435 6.61905 3.94373 6.61905 3.25217C6.61905 2.56062 6.03273 2 5.30952 2C4.58629 2 4 2.56062 4 3.25217C4 3.94373 4.58629 4.50435 5.30952 4.50435ZM5.30952 9.51304C6.03273 9.51304 6.61905 8.9524 6.61905 8.26087C6.61905 7.56934 6.03273 7.0087 5.30952 7.0087C4.58629 7.0087 4 7.56934 4 8.26087C4 8.9524 4.58629 9.51304 5.30952 9.51304ZM6.61905 13.2696C6.61905 13.9611 6.03273 14.5217 5.30952 14.5217C4.58629 14.5217 4 13.9611 4 13.2696C4 12.578 4.58629 12.0174 5.30952 12.0174C6.03273 12.0174 6.61905 12.578 6.61905 13.2696ZM10.5476 4.50435C11.2708 4.50435 11.8571 3.94373 11.8571 3.25217C11.8571 2.56062 11.2708 2 10.5476 2C9.82441 2 9.2381 2.56062 9.2381 3.25217C9.2381 3.94373 9.82441 4.50435 10.5476 4.50435ZM11.8571 8.26087C11.8571 8.9524 11.2708 9.51304 10.5476 9.51304C9.82441 9.51304 9.2381 8.9524 9.2381 8.26087C9.2381 7.56934 9.82441 7.0087 10.5476 7.0087C11.2708 7.0087 11.8571 7.56934 11.8571 8.26087ZM10.5476 14.5217C11.2708 14.5217 11.8571 13.9611 11.8571 13.2696C11.8571 12.578 11.2708 12.0174 10.5476 12.0174C9.82441 12.0174 9.2381 12.578 9.2381 13.2696C9.2381 13.9611 9.82441 14.5217 10.5476 14.5217Z" fill="#9D9FA3"/>
                    </svg>
                </button> -->
                <button class="modal__button" @click="handleModalDelete">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_12_285)">
                        <path d="M7 6H6V12H7V6Z" fill="#9D9FA3"/>
                        <path d="M10 6H9V12H10V6Z" fill="#9D9FA3"/>
                        <path d="M2 3V4H3V14C3 14.2652 3.10536 14.5196 3.29289 14.7071C3.48043 14.8946 3.73478 15 4 15H12C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14V4H14V3H2ZM4 14V4H12V14H4Z" fill="#9D9FA3"/>
                        <path d="M10 1H6V2H10V1Z" fill="#9D9FA3"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_12_285">
                        <rect width="16" height="16" fill="white"/>
                        </clipPath>
                    </defs>
                    </svg>
            </button>
            </div>
            
            <div class="input__group">
                <div class="MessageBlock">
                <button class="panel__button addCTA" @click="handleAddCTA">+ Add CTA</button>
                <h3 class="input__title">Ticker #{{ index + 1 }}</h3>
                <label for="input__text" class="ticker__messgage">Message</label>
                <input type="text" class="input__text" v-model="text" placeholder="Enter Message">     
                <label class="line__checkbox">
                <input type="checkbox" v-model="lineBreak" />
                <span class="checkmark"></span>
                With Break (Only applicable to CTA)
                </label>
                <!--<label for="text" class="label__text">ticker message</label>-->
                </div>

                <div class="CTABlock" v-for="(CTABlock, ctaIndex) in cta" :key="CTABlock.id">
                        <CTABlocks :CTABlock="CTABlock" :editMode="editMode" :tickerIndex="index" :ctaIndex="ctaIndex" :showError="showError" />
                </div>

                <div class="confirm__wrapper">
                    <button class="panel__button bg_white cancel" @click="handleCancelEdit">Cancel</button>
                    <button class="panel__button confirm" @click="handleConfirmEdit">Confirm</button>
                </div>

            </div>

        
        </div>
    </div>
  
</template>

<script setup>
import { fieldFactory } from '@/helper/fieldFactory';
import { store } from '@/helper/store';
import { nanoid } from 'nanoid'
import { ref, toRaw, watch } from 'vue';
import CTABlocks from '@/components/CTABlocks.vue'
import {saveHTML} from '@/helper/helper'

const emit = defineEmits(['dragStart']);

const props = defineProps({
    storeId:String,
    index: Number,
    startInEditMode: {
        type: Boolean,
        default: false
    }
})

const editMode = ref(props.startInEditMode)

// Add backup variables to store original values
const originalText = ref('')
const originalCta = ref([])
const originalLineBreak = ref(false)
const showError = ref(false)

const text = fieldFactory('text', props.storeId)
const cta = fieldFactory('cta', props.storeId)
const lineBreak = fieldFactory('lineBreak', props.storeId)

const handleAddCTA = () => {
    const id = nanoid(10)
    cta.value = [...toRaw(cta.value), {id,checkedCTA: 'Link'}]
    
}

const handleModalDelete = () => {
    store.value.splice(props.index, 1);
}

const startDrag = (event) => {
    // Emit a custom event to notify the parent component to start drag-and-drop reordering
    emit('dragStart', { index: props.index, event });
}

const handleEdit = () =>{
    // Find the store item to check if it has been confirmed
    const storeItem = store.value.find(item => item.id === props.storeId)

    storeItem.isDraggable = false
    
    if (storeItem && storeItem.hasBeenConfirmed) {
        // This is an existing ticker - backup original values before entering edit mode
        originalText.value = text.value
        originalCta.value = JSON.parse(JSON.stringify(toRaw(cta.value))) // Deep copy
        originalLineBreak.value = lineBreak.value
    }
    
    editMode.value = true
}

const handleConfirmEdit = () => {
    // Mark the ticker as confirmed
    const storeItem = store.value.find(item => item.id === props.storeId)

    // Early return on invalid CTA value
    const hasInvalidCTA = storeItem?.cta.some((el) => {
        return el.checkedCTA === "Link" &&
            !(el.ctaValue?.startsWith("https://") || el.ctaValue?.startsWith("$url"))
    });

    if (hasInvalidCTA) {
        showError.value = true
        return // Stop the function here
    }


    if (storeItem) {
        storeItem.hasBeenConfirmed = true
        storeItem.isDraggable = true
    }

    saveHTML()
    editMode.value = false
    showError.value = false
    

   
}

const handleCancelEdit = () =>{
    // Find the store item to check if it has been confirmed
    const storeItem = store.value.find(item => item.id === props.storeId)
    
    if (storeItem && !storeItem.hasBeenConfirmed) {
        // This is a new ticker that has never been confirmed - remove it
        store.value.splice(props.index, 1)
    } else {
        // This is an existing ticker - restore original values
        text.value = originalText.value
        cta.value = originalCta.value
        lineBreak.value = originalLineBreak.value
        editMode.value = false
        storeItem.isDraggable = true
    }
}

// Clear the startInEditMode flag after initialization
watch(editMode, (newValue) => {
    if (newValue && props.startInEditMode) {
        // Find the store item and clear the flag
        const storeItem = store.value.find(item => item.id === props.storeId)
        if (storeItem) {
            storeItem.startInEditMode = false
            // Don't backup values for new tickers - they don't need to be restored
        }
    }
}, { immediate: true })

</script>

<style>

</style>